import React from 'react';
import styled from 'styled-components';
import {conversationsStore} from '../../context/conversationsProvider';
import withMemoizedContexts from '../../context/contextContainerHoC';

export const ButtonGroupWrapper = styled.div`
   display: flex;
   flex-direction: row;
`;

const ButtonWrapper = styled.div`
   margin: 0 0.25rem;

   a {
      margin-right: 0;
   }
`;

const PrimaryButtonWrapper = styled(ButtonWrapper)`
   order: -1;
   margin-left: 0;

   button {
      padding: 0.5rem;
   }

   span:nth-child(1) {
      display: block;
   }

   span:nth-child(2) {
      display: none;
   }
`;

export const DataTableActionButtonGroupBase: React.FC<IDataTableActionButtonGroupProps> = ({primaryButton, otherButtons}) => (
   <ButtonGroupWrapper data-test-id="data-table-action-button-group">
      {otherButtons.map((b, i) => (
         <ButtonWrapper key={`${b.key}-${i}`}>
            {b}
         </ButtonWrapper>
      ))}
      <PrimaryButtonWrapper>
         {primaryButton}
      </PrimaryButtonWrapper>
   </ButtonGroupWrapper>
);

export interface IDataTableActionButtonGroupProps {
   primaryButton: React.ReactElement;
   otherButtons: React.ReactElement[];
}

const mapStatesToProps = (props: IDataTableActionButtonGroupProps): IDataTableActionButtonGroupProps => ({...props});

export default withMemoizedContexts(mapStatesToProps, conversationsStore)(DataTableActionButtonGroupBase);